import { t } from "@lingui/macro";

import { Button } from "@whoosh/design-system/src/components/controls";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";

type Props = {
  notes: string;
  setNotesOpen: (isOpen: boolean) => void;
  disabled?: boolean;
  onClear: () => void;
};

export const MemberNoteToTheStaffInfo = ({
  setNotesOpen,
  notes,
  onClear,
  disabled = false,
}: Props) => {
  if (!notes) {
    return null;
  }

  return (
    <VStack alignItems="center" gap={4}>
      <Box
        width="100%"
        backgroundColor="surface-secondary"
        p={6}
        borderRadius="4"
      >
        <Text color="text-primary" variant="mainBaseMedium">
          {notes}
        </Text>
      </Box>
      {!disabled ? (
        <HStack width="100%" gap={2}>
          <Box flexGrow={1} flexShrink={1}>
            <Button
              accessibilityLabel={t`Edit Note button`}
              width="100%"
              variant="secondary"
              onPress={() => setNotesOpen(true)}
              testID="booking-detail-edit-note-btn"
            >
              {t`Edit Note`}
            </Button>
          </Box>
          <Box flexGrow={1} flexShrink={1}>
            <Button
              accessibilityLabel={t`Remove Note button`}
              width="100%"
              variant="secondary"
              onPress={() => onClear()}
              testID="booking-detail-remove-note-btn"
            >
              {t`Remove Note`}
            </Button>
          </Box>
        </HStack>
      ) : null}
    </VStack>
  );
};
